import { defineMessages } from "react-intl";

const ACCOUNT_REMOVED_INDICATOR = "account-removed-indicator";

const accountRemovedIndicatorMessages = defineMessages({
  accountRemoved: {
    id: `${ACCOUNT_REMOVED_INDICATOR}.account-removed`,
    defaultMessage: "Account removed"
  },
  dataWillBeDeletedSoon: {
    id: `${ACCOUNT_REMOVED_INDICATOR}.data-will-be-deleted-soon`,
    defaultMessage:
      "Your account and personal data will be deleted soon. Please close any browser windows related to this account."
  }
});

export default accountRemovedIndicatorMessages;
